import axios from '@/http/axios/index.js'


export default {
    getRanges(payload) {
        return axios.get('warehouse/ranges/list', { params: payload }).then(res => res.data)
    },
    addRange(payload) {
        return axios.post('warehouse/ranges/store', payload).then(res => res.data)
    },
    updateRange(payload) {
        return axios.post('warehouse/ranges/update', payload).then(res => res.data)
    },
    deleteRange(payload) {
        return axios.delete('warehouse/ranges/delete', { params: payload }).then(res => res.data)
    },

}